<template>
    <div>
        <h1 v-if="mode == 'liste'">{{ client.name }} : Liste des configurations</h1>
        <h1 v-else>Choisissez votre configuration</h1>
        <div id="configTab" class="pl-list">
		    <div class="header">
		        <div class="header_line">
                    <div id="header_col1" class="header_col col1">Configurations</div>
                    <div id="header_col2" class="header_col col2">Date de dernière modification</div>
                    <div  v-if="showCol4()" id="header_col4" class="header_col col4">ID</div>
	    	    </div>
		    </div>
        
            <div class="content" ref="settingsBox">

                <setttingLine v-for="(setting) in orderSettingsObj" :key='setting.name' :settingObj='setting' :from='from' :mode="mode" ></setttingLine> 
            
                <div class="dummyline" :style="{'height': dummySettingsHeight+'px'}">
                    <div class="col col1">&nbsp;</div>
                    <div class="col col2">&nbsp;</div>
                    <div  v-if="mode == 'liste'" class="col col4">&nbsp;</div>
                </div>
            </div>
		    <div class="footer">
                <div v-if="isSuperAdmin() && mode == 'liste'" class="buttons">
                    <button id="btn_addSetting" type="button" class="liste_btn boutonTableau" title="Créer une configuration" @click="clickAddSetting()">Créer une configuration</button>
                </div>
		    </div>
        </div>
    </div>
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import SetttingLine from "@/components/SettingLine.vue"
    import { RoleEnum } from '../classes/enums';
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import axios from 'axios'

    export default { 
        name:"SelectDicoSetting",
        components: {
            "setttingLine":SetttingLine,
        },
        mixins: [FctUtils],
        props:{
            from:{},
            mode:"",
            client:{},
            settings:[],
        },
        data() {
            return {
                allsettings:[], // de base c'est un 'tableau' pour évité une erreur dans orderSettingsObj
                dummySettingsHeight:25,
            }
        },
        created() {
            // Recuperation des configurations des clients
            //
            axios(diagonalbackURL + "/settings",  defaultConfig)
            .then(reponse => {
                this.allsettings = reponse.data;
            })
            .catch(error => this.errorHandler(error));

        },
        async mounted() {
            this.$store.dispatch('loadSettings');

            // Evenement relatif a la creation/modification/suppresion d'une configuration
            //
            this.emitter.on('createSetting', settingdata => {
                this.createSetting(settingdata);
            });
            this.emitter.on('editSetting', settingdata => {
                this.editSetting(settingdata);
            });
            this.emitter.on('removeSetting', settingdata => {
                this.removeSetting(settingdata);
            });

        },
        computed: {
            settingsObj:function() {
                // Affichage dans la fiche Client
                if (this.mode == "liste") {
                    // On prend la liste passer en props
                    return this.settings;
                }
                // Affichage dans la page "Liste de toutes les configurations"
                else if (this.showCol4()) {
                    // On prend la liste de toutes les settings qui existe en tant que SUPERADMIN
                    return this.allsettings;
                }
                // Affichage dans la page "Liste des configurations"
                else {
                    // On prend la liste dans le store
                    //
                    return  this.$store.state.settings
                }
            },
            orderSettingsObj:function() {
                var orderResult = {};

                // Suivant le cas de this.settingsObj, il se peux qu'il soit vide au debut
                // ce qui provoque une erreur avec _.sort...
                // d'ou le try/catch 
                try {
                    orderResult = this.settingsObj.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                }
                catch(error) {
                    //console.error(this.settingsObj);
                }
                return orderResult;
            }
        },
        watch : {
            settingsObj: function (newQuestion, oldQuestion) {
                this.calcDummySettingsHeight();
            }
        },
        methods : {
            isSuperAdmin() {
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            showCol4() {
                return this.isSuperAdmin() && (this.mode == 'liste' || this.mode == 'superadmin' || this.$route.query.mode == 'superadmin')
            },
            clickAddSetting() {
                this.emitter.emit('showPLForm', {mode:'formSetting_new'});
            },
            calcDummySettingsHeight() {
                var calcHeight = 25;
                if (this.$refs.settingsBox != undefined && this.settingsObj.length != undefined) {
                    calcHeight = this.$refs.settingsBox.scrollHeight - (this.settingsObj.length*27);
                }

                this.dummySettingsHeight = calcHeight;
            },
            ////////////////////
            createSetting(aSettingdata) {
                console.log("Creation d'une configuration : " + aSettingdata.name)

                const params = JSON.stringify({
                    'name':aSettingdata.name,
                });

                axios.put(diagonalbackURL + "/clients/"+this.client.id+"/settings", params, defaultConfig)
                .then(reponse => {
                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));

            },
            editSetting(aSettingdata) {
                console.log("Modification d'une configuration : " + aSettingdata.name)

                const params = JSON.stringify({
                    'name':aSettingdata.name,
                });
                
                axios.post(diagonalbackURL + "/settings/"+aSettingdata.id, params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            removeSetting(toDeleteSetting) {
                console.log("Suppression d'une configuration : " + toDeleteSetting.name)
                /*
                axios.delete(diagonalbackURL + "/hosts/"+ toDeleteSetting.id,  defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
                */
            },
        },
        unmounted() {
            // Evenement relatif a la creation/modification/suppresion d'une configuration
            //
            this.emitter.off('createSetting');
            this.emitter.off('editSetting');
            this.emitter.off('removeSetting');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >


#configTab .col2 {
    width: 210px;
    border-right-width: 1px;
    padding-right : 10px;
}

#configTab .dummyline .col4 {
    border-right-width: 0px;
}

#configTab .dummyline .col:last-of-type {
	border-right-width: 0px !important;
}



</style>
